import * as React from 'react';
import uniqueId from 'lodash/uniqueId';

import AccessibleSVG from '../accessible-svg';

import { TwoTonedIcon } from '../iconTypes';

const ICON_CLASS = 'icon-iwork-pages-desktop';

class IconIWorkPagesDesktop extends React.Component<TwoTonedIcon> {
    static defaultProps = {
        className: '',
        height: 30,
        width: 30,
    };

    idPrefix = `${uniqueId(ICON_CLASS)}-`;

    render() {
        const { className, height, title, width } = this.props;
        return (
            <AccessibleSVG
                className={`${ICON_CLASS} ${className}`}
                height={height}
                title={title}
                viewBox="0 0 76.44 88.21"
                width={width}
            >
                <defs>
                    <linearGradient
                        gradientTransform="translate(0 132)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}a`}
                        x1="1.28"
                        x2="74.37"
                        y1="-88.49"
                        y2="-88.49"
                    >
                        <stop offset="0" stopColor="#fff" />
                        <stop offset="1" stopColor="#fff" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(0 132)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}b`}
                        x1="32.94"
                        x2="32.94"
                        y1="-107.62"
                        y2="-130.72"
                    >
                        <stop offset="0" stopColor="#fb960d" />
                        <stop offset="1" stopColor="#f98905" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(0 132)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}c`}
                        x1="44.69"
                        x2="45.78"
                        y1="-46.92"
                        y2="-46.42"
                    >
                        <stop offset=".11" stopColor="#686969" />
                        <stop offset="1" stopColor="#161717" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}d`}
                        x1="47.06"
                        x2="48.74"
                        y1="-44.82"
                        y2="-44.17"
                    >
                        <stop offset="0" stopColor="#c2edff" />
                        <stop offset=".15" stopColor="#def5ff" />
                        <stop offset=".55" stopColor="#c2edff" />
                        <stop offset=".88" stopColor="#607a7a" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}e`}
                        x1="46.95"
                        x2="53.83"
                        y1={-49}
                        y2={-49}
                    >
                        <stop offset="0" stopColor="#c2edff" />
                        <stop offset=".11" stopColor="#fff" />
                        <stop offset=".55" stopColor="#c2edff" />
                        <stop offset=".88" stopColor="#c2edff" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}f`}
                        x1="64.33"
                        x2="72.22"
                        y1="-111.66"
                        y2="-109.1"
                    >
                        <stop offset="0" stopColor="#e28d0c" />
                        <stop offset=".18" stopColor="#fedb65" />
                        <stop offset=".46" stopColor="#f27d09" />
                        <stop offset=".73" stopColor="#d05904" />
                        <stop offset="1" stopColor="#973e07" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}g`}
                        x1="60.41"
                        x2="70.38"
                        y1="-112.54"
                        y2="-112.54"
                    >
                        <stop offset="0" stopColor="#ae988a" />
                        <stop offset="1" stopColor="#8a715e" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}h`}
                        x1="60.42"
                        x2="70.32"
                        y1="-112.74"
                        y2="-112.74"
                    >
                        <stop offset="0" stopColor="#9ecdf7" />
                        <stop offset="1" stopColor="#cfe6ff" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}i`}
                        x1="60.41"
                        x2="70.31"
                        y1="-112.68"
                        y2="-112.68"
                    >
                        <stop offset="0" stopColor="#fff" />
                        <stop offset="1" stopColor="#e3f0ff" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}j`}
                        x1="49.52"
                        x2="56.46"
                        y1="-61.99"
                        y2="-59.99"
                    >
                        <stop offset="0" stopColor="#363838" />
                        <stop offset=".18" stopColor="#686969" />
                        <stop offset="1" stopColor="#161717" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(0 132)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}k`}
                        x1="25.81"
                        x2="25.81"
                        y1="-83.48"
                        y2="-108.14"
                    >
                        <stop offset="0" stopColor="#2dbffe" />
                        <stop offset="1" stopColor="#1b67f4" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}l`}
                        x1="30.43"
                        x2="30.43"
                        y1="-99.93"
                        y2="-87.01"
                    >
                        <stop offset="0" stopColor="#fdd500" />
                        <stop offset=".28" stopColor="#fa8f00" />
                        <stop offset=".67" stopColor="#f86900" />
                        <stop offset=".92" stopColor="#f27d09" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}m`}
                        x1="26.8"
                        x2="26.8"
                        y1="-96.66"
                        y2="-87.69"
                    >
                        <stop offset="0" stopColor="#dd5400" />
                        <stop offset="1" stopColor="#e54800" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}n`}
                        x1="24.84"
                        x2="24.84"
                        y1="-99.98"
                        y2="-95.54"
                    >
                        <stop offset=".01" stopColor="#fedb65" />
                        <stop offset=".31" stopColor="#fdd500" />
                        <stop offset=".67" stopColor="#fa8f00" />
                        <stop offset="1" stopColor="#f86900" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}o`}
                        x1="21.77"
                        x2="28.05"
                        y1="-89.92"
                        y2="-89.92"
                    >
                        <stop offset="0" stopColor="#fedb65" />
                        <stop offset=".24" stopColor="#fdd200" />
                        <stop offset="1" stopColor="#fa8f00" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}p`}
                        x1="23.88"
                        x2="23.88"
                        y1="-93.13"
                        y2="-87.17"
                    >
                        <stop offset="0" stopColor="#fb970f" />
                        <stop offset="1" stopColor="#d05904" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}q`}
                        x1="24.41"
                        x2="24.41"
                        y1="-99.77"
                        y2="-86.88"
                    >
                        <stop offset="0" stopColor="#fdd500" />
                        <stop offset=".21" stopColor="#fa8f00" />
                        <stop offset=".65" stopColor="#f86900" />
                        <stop offset=".97" stopColor="#f86900" />
                    </linearGradient>
                    <linearGradient
                        gradientTransform="translate(-2.48 129.27)"
                        gradientUnits="userSpaceOnUse"
                        id={`${this.idPrefix}r`}
                        x1="29.33"
                        x2="29.33"
                        y1="-86.99"
                        y2="-82.89"
                    >
                        <stop offset="0" stopColor="#6b5411" />
                        <stop offset=".1" stopColor="#515103" />
                        <stop offset=".26" stopColor="#1c3c00" />
                        <stop offset=".59" stopColor="#1b4406" />
                    </linearGradient>
                </defs>
                <path d="M.86 10.72L62.76.87l12 75.47-61.9 9.81z" fill="#9b9b9b" />
                <path
                    d="M76.1 5.27a5.77 5.77 0 0 0-4.87-2.88h-.37a3.66 3.66 0 0 0-2.67.75 1.71 1.71 0 0 0-.69.79l-.28.78a1.42 1.42 0 0 0-.8.91L65.28 9.1l-1.14-7A1.44 1.44 0 0 0 62.57 1L2.31 10.56a1.44 1.44 0 0 0-1.14 1.57l11.75 73.79a1.44 1.44 0 0 0 1.57 1.18l30.72-4.87v4.68l.2-.06a1.45 1.45 0 0 0 1.52 1.36 1.5 1.5 0 0 0 1-.51 1 1 0 0 0 .44-.49l.1-.16a1.1 1.1 0 0 0 .44-.36l3.87-5.6 22-3.49a1.43 1.43 0 0 0 1.14-1.6l-6.84-43 7.3-26a2.51 2.51 0 0 0-.28-1.76z"
                    fill="#9b9b9b"
                    opacity=".5"
                    style={{ isolation: 'isolate' }}
                />
                <path
                    d="M13.08 87a1.17 1.17 0 0 1-1.16-1L0 11.1a1.17 1.17 0 0 1 1-1.33L62.4 0h.13a1.14 1.14 0 0 1 1.15 1l12 74.93a1.18 1.18 0 0 1-1 1.34L13.21 87z"
                    fill="#b7b7b7"
                />
                <path d="M1.28 11l11.88 74.73L74.37 76 62.46 1.28z" fill={`url(#${this.idPrefix}a)`} />
                <path
                    d="M17.61 73.33l48.51-8.16.33 1.94-48.51 8.17zm1.29 3l23.51-4 .33 1.95-23.51 4zM17 70l48.53-8.05.32 1.94-48.54 8.03zm-.35-3.11L65.34 59l.32 1.95L17 68.81zM15 57l48.56-7.87.32 1.94L15.33 59zm.57 3.18l19.36-3.13.32 2-19.36 3.13zM14.64 54l48.7-7.87.32 1.95L15 56zm-.83-3.1l48.7-7.87.32 1.97-48.7 7.87zm29.44-8.25l18.62-3 .32 2-18.62 3zm-.5-3.34l18.55-3 .32 1.94-18.55 3zm-.48-3.05l18.62-3 .32 2-18.62 3zm-.47-3l13.5-2.18.32 2-13.5 2.12zm-.63-3.48l14.36-2.36.32 1.94-14.35 2.35zm-.47-3.24L56.19 24l.32 1.94L41 28.47zm-.57-3.24L56 20.68l.32 1.94-15.87 2.6z"
                    fill="#e2e2e2"
                />
                <path
                    d="M64.65 15l-4.83 14.81a.57.57 0 0 0 0 .26l-1.59 5.36c0 .15 0 .39.09.46a1.26 1.26 0 0 0 .22.39.29.29 0 0 0 0 .13L50.9 61.27l-4.63 16.21v3l7-1.11 5.29-15.78 7.64-24.68a2.32 2.32 0 0 1 .08-.36 1.28 1.28 0 0 0 .48-.09.35.35 0 0 0 .23-.23l.88-3.13z"
                    fill="#c4c4c4"
                />
                <path d="M64.65 15L62.53 1.64l-61.2 9.74 2.12 13.36z" fill="#f27d09" />
                <path d="M64.59 14.6L62.46 1.28 1.28 11l2.11 13.38z" fill={`url(#${this.idPrefix}b)`} />
                <path
                    d="M10.32 12.92a2 2 0 0 1 1.44.26 1.86 1.86 0 0 1 .7 1.27 1.7 1.7 0 0 1-1.62 2.13L9 16.87l.45 2.52-.82.13-1-6.16zm.18 3a1.42 1.42 0 0 0 1-.44 1.11 1.11 0 0 0 .18-.9 1 1 0 0 0-.44-.79 1.53 1.53 0 0 0-1.07-.13l-1.61.24.36 2.34zm4.42-3.67L18.28 18l-.91.15-1-1.76-2.6.4-.41 2-.83.13L14 12.39zM16 15.78l-1.4-2.68-.6 3zm6.11 1.61a3 3 0 0 1-1 .38 3.07 3.07 0 0 1-1.28 0 3 3 0 0 1-1-.55 3.13 3.13 0 0 1-.75-1 3.55 3.55 0 0 1-.46-1.12 4.11 4.11 0 0 1 0-1.31 2.91 2.91 0 0 1 .39-1.15 2.67 2.67 0 0 1 .8-.87 2.93 2.93 0 0 1 1.24-.47 3.94 3.94 0 0 1 1 0 2.58 2.58 0 0 1 .85.24 2.3 2.3 0 0 1 .69.55 2.48 2.48 0 0 1 .46.88l-.82.13a1.65 1.65 0 0 0-.32-.58 1.51 1.51 0 0 0-.47-.36 1.86 1.86 0 0 0-.54-.24 2.43 2.43 0 0 0-.66 0 1.89 1.89 0 0 0-1.4 1.08 2.56 2.56 0 0 0-.24.9 3.22 3.22 0 0 0 0 1 3.14 3.14 0 0 0 .28.9 2.57 2.57 0 0 0 .54.72 1.86 1.86 0 0 0 .75.45 1.83 1.83 0 0 0 .93 0 2.27 2.27 0 0 0 .84-.29 1.76 1.76 0 0 0 .85-1.22 2.21 2.21 0 0 0 0-.81l-2 .3-.1-.69 2.71-.44.41 3.4-.52.09-.29-.75a2.13 2.13 0 0 1-.85.83zm5.74-7.13L28 11l-3.44.53.3 2 3.26-.53.1.7-3.22.4.23 2.1 3.47-.53.1.69-4.32.74-1-6.17zm3.77.22a1.71 1.71 0 0 0-1.09-.13 1.91 1.91 0 0 0-.51.13 1.3 1.3 0 0 0-.41.24.86.86 0 0 0-.25.38.92.92 0 0 0 0 .52.69.69 0 0 0 .24.44 1.26 1.26 0 0 0 .49.21 3.74 3.74 0 0 0 .66.09h.75l.75.08a2.58 2.58 0 0 1 .68.22 1.48 1.48 0 0 1 .53.43 1.77 1.77 0 0 1 .16 1.72 1.94 1.94 0 0 1-.47.66 2.65 2.65 0 0 1-.72.43 3.49 3.49 0 0 1-.84.23 3.42 3.42 0 0 1-1 0 2.31 2.31 0 0 1-.88-.27 1.87 1.87 0 0 1-.66-.59 2.23 2.23 0 0 1-.35-.94l.78-.11a1.46 1.46 0 0 0 .26.65 1.56 1.56 0 0 0 .48.4 1.63 1.63 0 0 0 .62.17 2.66 2.66 0 0 0 .69 0 3.7 3.7 0 0 0 .55-.14 1.66 1.66 0 0 0 .47-.26A1 1 0 0 0 33 14a.84.84 0 0 0-.24-.49 1.37 1.37 0 0 0-.51-.26 3.63 3.63 0 0 0-.66-.1h-.75L30 13.1a3.28 3.28 0 0 1-.68-.19 1.27 1.27 0 0 1-.79-1.07 1.67 1.67 0 0 1 0-.83 1.7 1.7 0 0 1 .42-.64 2.42 2.42 0 0 1 .66-.43 3.26 3.26 0 0 1 .81-.23 3.32 3.32 0 0 1 .89 0 1.94 1.94 0 0 1 .77.25 1.7 1.7 0 0 1 .57.53 2.22 2.22 0 0 1 .33.85l-.77.11a1.29 1.29 0 0 0-.57-1z"
                    fill="#ee8100"
                />
                <path
                    d="M10.83 13.18a2 2 0 0 1 1.44.26 2.17 2.17 0 0 1 .42 2.71 1.88 1.88 0 0 1-1.34.69l-1.89.26.39 2.52-.85.13-1-6.16zm.17 3.06a1.47 1.47 0 0 0 1-.45 1.28 1.28 0 0 0-.28-1.69 1.51 1.51 0 0 0-1.06-.1L9 14.21l.36 2.23zm4.22-3.73l3.36 5.76-.91.14-1-1.75-2.57.44-.39 2-.84.13 1.44-6.54zM16.4 16L15 13.31l-.61 3zm6.07 1.64a2.81 2.81 0 0 1-1.07.42 2.77 2.77 0 0 1-1.28 0 2.87 2.87 0 0 1-1-.54 3.25 3.25 0 0 1-.72-1 3.74 3.74 0 0 1-.33-1.23 4.79 4.79 0 0 1 0-1.31 3.41 3.41 0 0 1 .33-1.15 2.66 2.66 0 0 1 .81-.86 2.78 2.78 0 0 1 1.24-.48 3.85 3.85 0 0 1 1 0 2.26 2.26 0 0 1 .85.25 2.15 2.15 0 0 1 .69.54 2.5 2.5 0 0 1 .47.88l-.83.13a1.51 1.51 0 0 0-.31-.57 1.44 1.44 0 0 0-.48-.37 1.9 1.9 0 0 0-.59-.15 2.43 2.43 0 0 0-.66 0 1.89 1.89 0 0 0-1.44 1.06 2.57 2.57 0 0 0-.25.9 4 4 0 0 0 0 1 3.16 3.16 0 0 0 .29.9 2.36 2.36 0 0 0 .53.72 1.93 1.93 0 0 0 .75.45 1.87 1.87 0 0 0 .94 0 2.34 2.34 0 0 0 .84-.29 1.83 1.83 0 0 0 .85-1.22 2.21 2.21 0 0 0 0-.81l-2 .3-.19-.64 2.71-.42.51 3.25-.52.09-.33-.73a2 2 0 0 1-.81.92zm5.74-7.2l.1.69-3.45.53.38 2 3.21-.49.1.69-3.31.49.33 2.14L29 16l.1.7-4.32.66-1-6.17zm3.8.31a1.81 1.81 0 0 0-1.1-.13 2.83 2.83 0 0 0-.5.13A1.51 1.51 0 0 0 30 11a1.08 1.08 0 0 0-.26.37 1.14 1.14 0 0 0 0 .52.62.62 0 0 0 .25.43 1.21 1.21 0 0 0 .49.22 3.74 3.74 0 0 0 .66.09h.75l.75.08a2.46 2.46 0 0 1 .68.22 1.57 1.57 0 0 1 .53.43A1.77 1.77 0 0 1 34 15a2 2 0 0 1-.47.67 2.55 2.55 0 0 1-.73.43 3.29 3.29 0 0 1-.83.23 3.42 3.42 0 0 1-1 0 2.65 2.65 0 0 1-.88-.27 2.08 2.08 0 0 1-.66-.59 2.2 2.2 0 0 1-.35-.94l.78-.12a1.38 1.38 0 0 0 .26.65 1.46 1.46 0 0 0 .48.41 1.84 1.84 0 0 0 .62.17 2.66 2.66 0 0 0 .69 0 2.55 2.55 0 0 0 .54-.15 1.4 1.4 0 0 0 .48-.26.94.94 0 0 0 .36-1 .82.82 0 0 0-.24-.49 1.37 1.37 0 0 0-.51-.26 3 3 0 0 0-.66-.1h-1.52a2.64 2.64 0 0 1-.68-.19 1.43 1.43 0 0 1-.52-.39 1.4 1.4 0 0 1-.3-.68 1.67 1.67 0 0 1 0-.83 1.8 1.8 0 0 1 .41-.64 2.48 2.48 0 0 1 .73-.45 3.31 3.31 0 0 1 .8-.23 3.39 3.39 0 0 1 .9 0 1.85 1.85 0 0 1 .76.25 1.73 1.73 0 0 1 .58.53 2.22 2.22 0 0 1 .33.85l-.78.11a1.29 1.29 0 0 0-.56-.92z"
                    fill="#fff"
                />
                <path
                    d="M56.4 33.63a1.44 1.44 0 0 0 .36.91l7.64 2.23s.66 0 .78-.32c0 0 .3-2-3.6-2.88s-4.64-.36-5.18.06z"
                    fill="#973e07"
                />
                <circle cx="45.24" cy="85.33" fill={`url(#${this.idPrefix}c)`} r=".61" />
                <path
                    d="M44.66 84.21v.69a.3.3 0 0 0 .22.2 1.16 1.16 0 0 1 .76.27.32.32 0 0 1 .1.2s.12.13.23-.13l.38-.59a.92.92 0 0 0-.62-.62 2 2 0 0 0-1.07-.02z"
                    fill={`url(#${this.idPrefix}d)`}
                />
                <path d="M67.12 2.61s.36-.64 2.44-.55c0 0 3.41 0 4.32 2.8z" fill="#b98421" />
                <path
                    d="M44.47 75.68v8.64a1.7 1.7 0 0 1 1.13.15c.65.28.57.54.57.54h.2a.18.18 0 0 0 .15-.08L51.33 78a7.19 7.19 0 0 0-6.86-2.32z"
                    fill={`url(#${this.idPrefix}e)`}
                />
                <path
                    d="M56.4 33.63L66.68 3s.34-.91 2.88-.82a5.2 5.2 0 0 1 3.74 1.65 2.31 2.31 0 0 1 .61 1.67l-8.76 30.91a.35.35 0 0 1-.23.23s.19-.19.17-.36A.58.58 0 0 0 65 36a5.31 5.31 0 0 0-1.11-1.11 10.68 10.68 0 0 0-5.39-1.7 3.67 3.67 0 0 0-1.73.3.5.5 0 0 0-.22.61 1.56 1.56 0 0 1-.1-.42z"
                    fill={`url(#${this.idPrefix}f)`}
                />
                <path
                    className="q"
                    d="M50.6 77.22a6.86 6.86 0 0 0-.77-.56 2.19 2.19 0 0 0-.43-.15l-3.59 8a.7.7 0 0 1 .36.36l4.59-7.54z"
                />
                <path
                    d="M67.89 5.59l-7.21 22.68c-.3 1-.86.82-.86.82l-.91-.09a2.8 2.8 0 0 1-.76-.41A.39.39 0 0 1 58 28l7.59-23.3c.16-.46.46-.36.46-.36l1.23.1a.53.53 0 0 1 .5.39 3.9 3.9 0 0 1 .11.76z"
                    fill={`url(#${this.idPrefix}g)`}
                />
                <path
                    d="M58.15 28.57l1.28.16s.56.16.86-.82l7.55-23a.52.52 0 0 0-.5-.41l-1.22-.1s-.32-.16-.54.36L58 28a.4.4 0 0 0 .14.55z"
                    fill={`url(#${this.idPrefix}h)`}
                />
                <path
                    d="M67.57 4.47L60 27.52c-.3 1-.86.82-.86.82L58 28.2a.35.35 0 0 0 .21.34l1.28.16s.57.16.87-.82l7.55-23a.49.49 0 0 0-.34-.41z"
                    fill={`url(#${this.idPrefix}i)`}
                />
                <path
                    d="M51.4 77.94l5.4-16.14a4.25 4.25 0 0 0-2-1.53 10.26 10.26 0 0 0-2.36-.8 7.65 7.65 0 0 0-3.3 0l-4.63 16.21a7 7 0 0 1 3.63.4 6.91 6.91 0 0 1 3.26 1.86z"
                    fill={`url(#${this.idPrefix}j)`}
                />
                <path
                    d="M56.71 34.6s.15-1.1 1.77-1a11.11 11.11 0 0 1 3.51.78 6.16 6.16 0 0 1 2.34 1.44s.37.35 0 1.44l-7.64 24.68a4.9 4.9 0 0 0-2-1.52 8.28 8.28 0 0 0-2.3-.95 7.65 7.65 0 0 0-3.3 0z"
                    fill="none"
                />
                <path className="q" d="M45.91 84.49l-.39.81.11.1.51-.73z" />
                <path d="M10.43 28.26L38 23.86l3.22 20.33-27.52 4.33z" fill={`url(#${this.idPrefix}k)`} />
                <path d="M27.86 30s1-1.44 2.16-1.44c0 0 .68 0 .58 1z" fill="#f98905" />
                <path
                    d="M22.85 31.84a.74.74 0 0 1 .38-.69 8.33 8.33 0 0 0 2-1.14 1.44 1.44 0 0 1 1.28-.27c.89.16 1 0 1 0a3.29 3.29 0 0 1 1.32.16 2.49 2.49 0 0 0 1.17-.32 2.28 2.28 0 0 1 1.7-.07 4.19 4.19 0 0 0 .94.43s1.28.19 1 1a2 2 0 0 1-.51 1 13.38 13.38 0 0 0-1.78 3.9l-1.11 3.43s-.94 2.18-2.25 2.6l-.23.34-1-.06S25 39.86 23 36.88a9.7 9.7 0 0 1-.74-3.64 1.48 1.48 0 0 1 .39-1 .71.71 0 0 0 .2-.4z"
                    fill={`url(#${this.idPrefix}l)`}
                />
                <path
                    d="M32.34 33s-1.08 1.81-2 3.17c0 0-.38.15-.43 1.44V40a5.45 5.45 0 0 0 .39-.76l1.05-3.49A18.83 18.83 0 0 1 32.4 33z"
                    fill="#dd5400"
                />
                <path
                    d="M25.57 35.71a12.8 12.8 0 0 1-3-3 .21.21 0 0 0-.26 0 1 1 0 0 0-.13.59 9.94 9.94 0 0 0 .73 3.7c1.44 2.1 2.72 3.86 3.37 4.71a28.46 28.46 0 0 0 .16-4.33 1.51 1.51 0 0 0-.87-1.67z"
                    fill={`url(#${this.idPrefix}m)`}
                />
                <path
                    d="M20.12 29.62a3.76 3.76 0 0 0 1.28-.21s.53-.38 1.34.21a6.13 6.13 0 0 1 1.86 1.65l-2 2.48z"
                    fill={`url(#${this.idPrefix}n)`}
                />
                <path
                    d="M19.29 36.67a5.29 5.29 0 0 1 2.16.22L25.57 42s-.59.43-1.77-.48a16.42 16.42 0 0 0-2.38-3 14.09 14.09 0 0 0-2.13-1.81z"
                    fill={`url(#${this.idPrefix}o)`}
                />
                <path
                    d="M17.4 36.53a1.4 1.4 0 0 0 .82-.26s.25-.39 1.08.26a26.21 26.21 0 0 1 2.58 2.24A12.89 12.89 0 0 1 23 40.32 4.15 4.15 0 0 0 25.2 42h.2s-.68.34-2-.74a18.81 18.81 0 0 1-1.54-1.68 7.62 7.62 0 0 0-3.46-2.71l-.61-.12a.27.27 0 0 1-.39-.21z"
                    fill={`url(#${this.idPrefix}p)`}
                />
                <path
                    d="M19.47 29.65a6.51 6.51 0 0 1-1.44 1l-.69.5a.71.71 0 0 0 0 .91 20.32 20.32 0 0 1 3.06 3.73l2.19 3.5a8.84 8.84 0 0 0 3.23 3.14l.85-.26-4.17-9.58a9.69 9.69 0 0 0-1.74-2.76 1.12 1.12 0 0 0-1.29-.18z"
                    fill={`url(#${this.idPrefix}q)`}
                />
                <path d="M25.4 43s-.13-.83 1.52-1.08a1.42 1.42 0 0 1 1.44.62z" fill="#522d2e" />
                <path
                    d="M27.4 43.24s-.17-.29.41-.49l.49-.1a.11.11 0 0 0 0-.16 2.72 2.72 0 0 0-1.57-.14c-1.08.19-1.36.55-1.36.55v.2h.52c.56 0 .59.4.59.4l.68 2.88.72-.11z"
                    fill={`url(#${this.idPrefix}r)`}
                />
            </AccessibleSVG>
        );
    }
}

export default IconIWorkPagesDesktop;
